module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor05-deed7579da986e2a5c3e7475b92c81a9.jpg";